import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer } from "@angular/platform-browser";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { AuditTrailService } from "../audit-trail.service";

@Component({
  selector: "app-check-document-image",
  templateUrl: "./check-document-image.component.html",
  styleUrls: ["./check-document-image.component.scss"],
})
export class CheckDocumentImageComponent implements OnInit {
  imageUrl: string = "";
  image: any;
  backImage: any;
  constructor(
    private domSanitizer: DomSanitizer,
    private auditTrailService: AuditTrailService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {}

  async getImage() {
    // await this.auditTrailService.downloadFileV1(this.imageUrl).subscribe(async (response: any) => {
    //   if (response != null && !response.error) {
    // var binary = "";
    // var bytes = new Uint8Array(response);
    // var len = bytes.byteLength;
    // for (var i = 0; i < len; i++) {
    //   binary += String.fromCharCode(bytes[i]);
    // }
    // let url = window.btoa(binary);

    // let file = new Blob([response], { type: "image/*" });
    // var fileURL = URL.createObjectURL(file);
    // this.image = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);
    // // setTimeout(() => {
    // //   let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
    // //   const dialog = this.dialog.open(ViewDocumentComponent, {
    // //     disableClose: false,
    // //     width: "600px",
    // //     data: this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url),
    // //   });
    // // }, 100);

    const progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
    let imageBackUrl = null;
    let image = this.imageUrl.split(",");
    console.log(image);

    if (image[1] != undefined) {
      await this.auditTrailService.downloadFileV1(image[1].split("/").pop(), null).subscribe((response: any) => {
        progressSpinnerDialog.close();
        if (response != null && !response.error) {
          let file = new Blob([response], { type: "image/*" });
          var fileURL = URL.createObjectURL(file);
          imageBackUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
          setTimeout(() => {
            var binary = "";
            var bytes = new Uint8Array(response);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            let url = window.btoa(binary);
            this.backImage = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);

            // const blob = new Blob([file], { type: "image/*" });
            // const downloadUrl = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = downloadUrl;
            // link.download = "image_back.jpg";
            // link.click();
          }, 100);
        } else {
          this.errorToast();
        }
      });
    } else {
      this.backImage = "";
    }
    await this.auditTrailService.downloadFileV1(image[0].split("/").pop(),null).subscribe((response: any) => {
      progressSpinnerDialog.close();
      if (response != null && !response.error) {
        let file = new Blob([response], { type: "image/*" });
        var fileURL = URL.createObjectURL(file);
        setTimeout(() => {
          var binary = "";
          var bytes = new Uint8Array(response);
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          let url = window.btoa(binary);
          this.image = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);

          // const blob = new Blob([file], { type: "image/*" });
          // const downloadUrl = window.URL.createObjectURL(blob);
          // const link = document.createElement("a");
          // link.href = downloadUrl;
          // link.download = "image.jpg";
          // link.click();
        }, 100);
      } else {
        this.errorToast();
      }
    });

    //   }
    // });
  }
  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
